import { Controller } from "@hotwired/stimulus";
import { QueryClientProvider } from "@tanstack/react-query";
import React, { Suspense } from "react";
import { createRoot, type Root } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { queryClient } from "~/components/providers";
import { AirbrakeProvider } from "~/components/providers/airbrake";
import i18n from "~/lib/i18n";
import { Feedback } from "~/routes/feedback";

const FeedbackBridge = () => {
  React.useEffect(() => {
    i18n.changeLanguage(document.documentElement.lang);
  }, []);

  return <Feedback />;
};

export default class extends Controller {
  declare root: Root;
  declare component: string;

  connect() {
    this.renderComponent();
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  renderComponent() {
    this.root = createRoot(this.element);
    this.root.render(
      <Suspense>
        <AirbrakeProvider>
          <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
              <FeedbackBridge />
            </QueryClientProvider>
          </I18nextProvider>
        </AirbrakeProvider>
      </Suspense>,
    );
  }
}
